import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token"); // Replace with your actual Bearer Token
// const baseUrl = "http://localhost:8081/api";
const user = JSON.parse(localStorage.getItem("user"));
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json", // Assuming you're sending JSON data
};

console.log("Headers: ", headers);
const Shop = {
  getAllShops: () =>
    axios.get(
      `${baseUrl}/building-shops/branch-shops/?branchId=${user.branchId}`,
      { headers: headers }
    ),
  getFloorShops: (floorId) =>
    axios.get(
      `${baseUrl}/building-shops/floor-shops/?floorId=${floorId}&branchId=${user.branchId}`,
      { headers: headers }
    ),
  getRents: (shopId) =>
    axios.get(
      `${baseUrl}/general-journals/received-payments-by-shop?shopId=${shopId}/?branchId=${user.branchId}`,
      { headers: headers }
    ),

  getAllShopkeepers: (shopId) =>
    axios.get(
      `${baseUrl}/shop-contracts/building-shop-shopkeepers/?shopId=${shopId}&branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  getAvailableShops: () =>
    axios.get(
      `${baseUrl}/building-shops/non-occupied-shops/?branchId=${user.branchId}`,
      { headers: headers }
    ),

  getOne: (id) =>
    axios.get(`${baseUrl}/building-shops/${id}`, { headers: headers }),

  addContract: (data) =>
    axios.post(`${baseUrl}/shop-contracts`, data, { headers }),
  cancellContract: (data) =>
    axios.put(`${baseUrl}/shop-contracts/cancel/${data.id}`, data, { headers }),

  add: (data) =>
    axios.post(`${baseUrl}/building-shops`, data, { headers: headers }),

  importShops: (data) =>
    axios.post(
      `${baseUrl}/building-shops/upload/?branchId=${user.branchId}`,
      data,
      { headers: { ...headers, "Content-Type": "multipart/form-data" } }
    ),

  update: (data) =>
    axios.put(
      `${baseUrl}/building-shops/?branchId=${user.branchId}&sort=id,asc`,
      data,
      {
        headers: headers,
      }
    ),
  remove: (id) =>
    axios.delete(`${baseUrl}/building-shops/${id}`, { headers: headers }),
};

export default Shop;
